export const blockIconsPhotoandimageContrastNew = (
	<span className='material-symbols-outlined'>contrast</span>
);
